<template>
    <div v-if="isOpen" class="modal fade show" tabindex="-1" aria-labelledby="apiKeyModal" aria-hidden="true" style="display: block; background: rgba(0,0,0,0.5); z-index: 9999;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                            <h1 class="mb-0">API Key Generated</h1>
                            <button
                                @click="closeModal"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                    <div class="col-11 py-1 mx-auto">
                        <p class="text-center mt-1">Please copy this API key now. You won't be able to see it again!</p>
                        
                        <div class="input-group mt-2 mb-2">
                            <input type="text" class="form-control" :value="apiKey" readonly>
                            <button class="btn btn-outline-primary" type="button" @click="copyKey">
                                <i class="fas fa-copy"></i> Copy
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false
    },
    apiKey: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['close']);
const showSuccess = inject('showSuccess');

const closeModal = () => {
    emit('close');
}

const copyKey = () => {
    navigator.clipboard.writeText(props.apiKey).then(() => {
        showSuccess('API key copied to clipboard!');
    }).catch(err => {
        console.error('Could not copy text: ', err);
    });
}
</script>
